<template>
  <div class="intro-push-container">
    <common-header></common-header>
    <div class="header-banner"></div>
    <!-- 闪退采集工具价值 -->
    <common-advantage :advantages="valuesList"></common-advantage>
    <!-- 闪退采集工具优势 -->
    <common-advantage :advantages="advantageList"></common-advantage>
    <!-- 闪退采集工具功能介绍 -->
    <common-advantage :advantages="functionList"></common-advantage>
    <!-- 闪退采集工具架构图 -->
    <div class="application-wrap resolution-wrap">
      <common-application title="闪退采集工具架构图" :tabcontent="tabcontent"></common-application>
    </div>
    <!-- 闪退采集工具应用案例 -->
    <div class="application-wrap appcase-wrap">
      <common-application title="闪退采集工具应用案例" :tabcontent="tabcontent2"></common-application>
    </div>
    <common-footer></common-footer>
  </div>
</template>
<script>
import mainHeader from '@/components/mainheader'
import mainFooter from '@/components/mainfooter'
import advantage from '@/components/advantage'
import application from '@/components/application'
export default {
  name: 'app',
  components: {
    'common-header': mainHeader,
    'common-footer': mainFooter,
    'common-advantage': advantage,
    'common-application': application
  },
  data () {
    return {
      tabcontent: ['flash-banner2'],
      tabcontent2: ['flash-banner3'],
      currentTabIndex: 0,
      currentTabIndex2: 0,
      hoverIndex: -1,
      valuesList: {
        title: '闪退采集工具价值',
        mulitrow: false,
        list: [
          {
            key: '0',
            title: ' 降低客户端错误采集成本',
            desc: '提供全面的错误采集SDK, 提供简易的通用API, 开发人员只需要处理闪退SDK回调的错误信息即可',
            iconname: 'icon-flash-01'
          },
          {
            key: '1',
            title: '让开发人员迅速排查问题，提高App的质量',
            desc: 'APP运行中实时监控采集运行中发生的Java Crash,Native Crash, Android ANR 错误信息, 多个维度监控用户使用时发生异常,对性能基本无影响',
            iconname: 'icon-flash-02'
          },
          {
            key: '2',
            title: '闪退采集信息维度多',
            desc: '时间维度:异常时间、运行时长,  状态维度:内存、网络、上下文数据、执行路径、线程状态,  位置维度:组件/模块/页面、类/方法/行号,  归因维度:异常堆栈、错误描述,   身份维度:机型、账号、设备ID',
            iconname: 'icon-flash-03'
          }
        ]
      },
      advantageList: {
        title: '闪退采集工具优势',
        mulitrow: true,
        list: [
          {
            key: '0',
            title: '快速接入',
            desc: '客户端可以较快速的接入其app，api使用极简',
            iconname: 'icon-flash-04'
          },
          {
            key: '1',
            title: '业界一流的稳定性与兼容性',
            desc: '在汽车之家App数亿台设备上稳定运行',
            iconname: 'icon-flash-05'
          },
          {
            key: '2',
            title: '闪退场景覆盖完',
            desc: '可采集Native闪退日志、采集ANR日志',
            iconname: 'icon-flash-06'
          },
          {
            key: '3',
            title: '丰富的闪退现场信息',
            desc: '可采集闪退发生的页面和路径，记录用户轨迹，可进行现场复原',
            iconname: 'icon-flash-07'
          },
          {
            key: '4',
            title: '闪退采集的收集率高',
            desc: 'Java Crash收集率99%以上, ANR收集率50%以上,Native Crash收集率90%以上，iOS收集率95%以上',
            iconname: 'icon-flash-08'
          }
        ]
      },
      functionList: {
        title: '闪退采集工具功能介绍',
        mulitrow: true,
        list: [
          {
            key: '0',
            title: '客户端原生闪退的精准收集',
            desc: '收集原生Java/oc闪退信息，通过用户行为路径准确定位异常位置',
            iconname: 'icon-flash-09'
          },
          {
            key: '1',
            title: 'Native Crash闪退信息收集',
            desc: '成熟的Native闪退监控方案, 直接定位异常位置, 输出完善的异常信息',
            iconname: 'icon-flash-10'
          },
          {
            key: '2',
            title: 'ANR信息收集',
            desc: '完备的ANR信息收集功能, 多方位的采集用户使用过程中发生的ANR卡死信息',
            iconname: 'icon-flash-11'
          }
        ]
      }
    }
  },
  created(){
    // pv上报
    // 埋点
    window.pvTrack = {
      site: 144,
      category: 1727,
    }
    window.trackPageView()
  },
  methods: {}
}
</script>

<style scoped>
.intro-push-container {
  background-color: #F7F9FA;
}
.header-banner {
  width: 100%;
  height: 542px;
  background-size: cover;
  background-image: url('./../assets/images/index-banner_flash.png');
  background-repeat: no-repeat;
  background-position: -2px 0;
  position: relative;
  top: -1px;
}
.application-wrap {
  margin-bottom: -2px;
}
.resolution-wrap {
  padding-top: 10px;
  background: #333B5B;
  margin-top: 50px;
}
.appcase-wrap {
  padding-top: 10px;
  background: #333B5B;
  margin-top: 0;
}
.intro-zhibo-container .application-title .line i {
  background: rgba(202,206,213,.5);
}
</style>



// WEBPACK FOOTER //
// src/view/intro_flashback.vue